<template>
  <MainLayout page-name="merge-data">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="create" @click="clickCreate">データ作成</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">新規追加</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="create" @click="clickDataCheck">データチェック</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true" />
        <RegistrationSymbol v-model="simpleSearchFormModel.registration_symbol" :searchCond="true" :autocomplete-list="registrationSymbolSet" />
        <ActionType v-model="simpleSearchFormModel.action_type" :searchCond="true" :initialize="true" mode="all" />
        <RouteCode v-model="simpleSearchFormModel.route_code" :searchCond="true" :initialize="true" label="" placeholder="線別" />
        <!-- <CustomerCode v-model="simpleSearchFormModel.operator_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true" label="運航者" prop="operator_code" /> -->
        <CustomerCode v-model="simpleSearchFormModel.bill_to_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true" label="請求先" prop="bill_to_code" />
        <FlightPurposeCode v-model="simpleSearchFormModel.flight_purpose_code" :searchCond="true" :initialize="true" mode="search" label="" placeholder="飛行目的" />
        <div class="dummy">
          <AircraftAttribute :initialize="true" />
        </div>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :data-check="true"
      :default-sort="{ prop: 'action_time', order: 'ascending' }"
      :selectable="deletable"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <RegistrationSymbolColumn :sortable="true" />
        <ActionTypeNameColumn label="着離陸・入出庫区分" :sortable="true" />
        <DateTimeColumn label="日時" prop="action_time" :sortable="true" />
        <CallsignColumn :sortable="true" />
        <RouteCodeColumn :sortable="true" />
        <CustomerCodeColumn label="運航者" prop="operator_code" :sortable="true"/>
        <CustomerCodeColumn label="請求先" prop="bill_to_code" :sortable="true"/> -->
        <!-- <ModelCodeColumn :sortable="true" /> -->
        <!--<AircraftTypeColumn :sortable="true" />-->
        <!-- <BlankColumn />
        <RegistTypeColumn :sortable="true" label="追加" />
        <TransferredColumn :sortable="true" :transferred="transfferd" />
        <DataCheckFlagColumn prop="data_check_status" :sortable="true" :correct="correct" />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
        <!-- <SelectedColumn :prop="selected" :selectable="deletable"/> -->
        <RegistrationSymbolColumn />
        <ActionTypeNameColumn label="着離陸・入出庫区分"/>
        <DateTimeColumn label="日時" prop="action_time"/>
        <CallsignColumn/>
        <RouteCodeColumn/>
        <CustomerCodeColumn label="運航者" prop="operator_code"/>
        <CustomerCodeColumn label="請求先" prop="bill_to_code"/>
        <FlightPurposeCodeColumn label="飛行目的" prop="flight_purpose_code"/>
        <BlankColumn />
        <RegistTypeColumn label="追加" />
        <TransferredColumn :transferred="transfferd" />
        <BillingExclusionFlagColumn prop="billing_exclusion_flag" :billingExclusive="billingExclusive" />
        <DataCheckFlagColumn prop="data_check_status" :correct="correct" />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" />
      </template>
    </Table>
    <MergeDataCreateDialog
      :visible.sync="createDialogVisible"
      @refresh="refreshSearch"
    />
    <MergeDataCheckDataDialog
      :visible.sync="checkDataDialogVisible"
      @refresh="refreshSearch"
    />
    <MergeDataRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <MergeDataDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      @search="detailSearch"
    />
    <MergeDataEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import FlightPurposeCode from '@/components/molecules/form/select/FlightPurposeCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'

// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
// import SelectedColumn from '@/components/molecules/table/SelectedColumn.vue'
import RegistrationSymbolColumn from '@/components/molecules/table/RegistrationSymbolColumn.vue'
import ActionTypeNameColumn from '@/components/molecules/table/ActionTypeNameColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
// import ModelCodeColumn from '@/components/molecules/table/ModelCodeColumn.vue'
// import AircraftTypeColumn from '@/components/molecules/table/AircraftTypeColumn.vue'
import CallsignColumn from '@/components/molecules/table/CallsignColumn.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import CustomerCodeColumn from '@/components/molecules/table/CustomerCodeColumn.vue'
import FlightPurposeCodeColumn from '@/components/molecules/table/FlightPurposeCodeColumn.vue'
import DataCheckFlagColumn from '@/components/molecules/table/DataCheckFlagColumn.vue'
import BillingExclusionFlagColumn from '@/components/molecules/table/BillingExclusionFlagColumn.vue'
import RegistTypeColumn from '@/components/molecules/table/RegistTypeColumn.vue'
import TransferredColumn from '@/components/molecules/table/TransferredColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import MergeDataCreateDialog from '@/components/pages/data/mergeData/MergeDataCreateDialog.vue'
import MergeDataCheckDataDialog from '@/components/pages/data/mergeData/MergeDataCheckDataDialog.vue'
import MergeDataRegisterDialog from '@/components/pages/data/mergeData/MergeDataRegisterDialog.vue'
import MergeDataDetailSearchDialog from '@/components/pages/data/mergeData/MergeDataDetailSearchDialog.vue'
import MergeDataEditDialog from '@/components/pages/data/mergeData/MergeDataEditDialog.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    ActionType,
    RouteCode,
    CustomerCode,
    RegistrationSymbol,
    FlightPurposeCode,
    SimpleSearch,
    Table,
    // SelectedColumn,
    RegistrationSymbolColumn,
    ActionTypeNameColumn,
    DateTimeColumn,
    // ModelCodeColumn,
    // AircraftTypeColumn,
    CallsignColumn,
    RouteCodeColumn,
    CustomerCodeColumn,
    FlightPurposeCodeColumn,
    DataCheckFlagColumn,
    BillingExclusionFlagColumn,
    RegistTypeColumn,
    TransferredColumn,
    BlankColumn,
    MenuColumn,
    MergeDataCreateDialog,
    MergeDataCheckDataDialog,
    MergeDataRegisterDialog,
    MergeDataDetailSearchDialog,
    MergeDataEditDialog
  },
  mixins: [
    CustomerAutocompleteLoader,
    RegistrationSymbolAutocompleteLoader,
    AirportAutocompleteLoader
  ],
  data () {
    return {
      title: '着離陸・入出庫データ',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        action_type: '',
        route_code: '',
        // operator_code: '',
        registration_symbol: '',
        bill_to_code: '',
        flight_purpose_code: ''
      },
      currentRow: {},
      createDialogVisible: false,
      checkDataDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('mergeDataSearchCond')
    this.loadRegistrationSymbol()
    this.loadCustomer()
    this.loadAirport()
  },
  methods: {
    clickCreate () {
      this.createDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDataCheck () {
      this.checkDataDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('mergeDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('mergeDataSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('mergeDataSearchCond'))
      this.$axios
        .get('/search-merge-data', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('mergeDataSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('mergeDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      }
      this.search()
    },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      const currentRow = { ...row }
      if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
        currentRow.billing_ym = ''
      }
      this.currentRow = currentRow
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/merge-data', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    },
    deletable (row, index) {
      // 削除可能条件
      return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()))
    },
    transfferd (row, index) {
      if (parseInt(this.simpleSearchFormModel.billing_ym) >= parseInt(this.getDefaultBillingYm())) {
        return parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())
      } else {
        return parseInt(row.billing_ym) < parseInt(this.simpleSearchFormModel.billing_ym)
      }
    },
    correct (row, index) {
      return row.data_check_status === 'OK'
    },
    billingExclusive (row, index) {
      return (row.billing_exclusion_flag !== null)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      // width: 13em;
      width: 10em;
    }
  }
}
.route-code {
  ::v-deep .el-form-item__content {
    width: 6.5em;
  }
}
.dummy {
  display: none;
}
</style>
<style lang="scss">
.merge-data .el-table {
  th.customer-code, td.customer-code {
    width: 6em !important;
  }
  td.flight-purpose-code, th.flight-purpose-code {
    width: 6.6em !important;
  }
  td.route-code, th.route-code {
    width: 4.5em !important;
  }
  td.transferred, th.transferred {
    width: 4.5em !important;
  }
  td.billing_exclusion_flag, th.billing_exclusion_flag {
    width: 4.5em !important;
  }
  td.data-check-flag, th.data-check-flag {
    width: 4.5em !important;
  }
}
</style>
